import { isUnauthorized } from "@onadssuper/api-client";
import { redirect } from "@tanstack/react-router";
import type { RouterContext } from "../../router-context";
import { markSignedIn } from "../../lib/session";

/** Route guard: the signed-in user (from `me.get`), or a redirect to sign-in. */
export const requireUser = async (context: RouterContext, returnTo: string) => {
  try {
    const me = await context.queryClient.ensureQueryData(context.trpc.me.get.queryOptions());
    markSignedIn();
    return me;
  } catch (error) {
    if (isUnauthorized(error)) throw redirect({ to: "/sign-in", search: { redirect: returnTo } });
    throw error;
  }
};
